import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { installChunkRecovery, createI18n } from "@gaming/shared";
import messages from "./locales";
import { reveal } from "./reveal";
import "./style.css";

// Recovers from a deploy landing mid-session — see chunkRecovery.
installChunkRecovery(router);

// Before mount, so the first paint is already in the player's language rather
// than flashing English and correcting itself.
const i18n = createI18n(messages);

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .directive("reveal", reveal)
  .mount("#app");
